import React from 'react'

interface IconProps {
  className?: string
}

export const BrandIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M3.03293 10L20.9671 10C21.9872 10 22.3878 8.64858 21.539 8.07059L13.1438 2.35375C12.4512 1.88208 11.5488 1.88208 10.8562 2.35375L2.46102 8.07059C1.61224 8.64858 2.01282 10 3.03293 10Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <rect 
        x="4" 
        y="10" 
        width="5" 
        height="8" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <rect 
        x="15" 
        y="10" 
        width="5" 
        height="8" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M19.382 18C19.7607 18 20.107 18.214 20.2764 18.5528L21.2764 20.5528C21.6088 21.2177 21.1253 22 20.382 22L3.61803 22C2.87465 22 2.39116 21.2177 2.72361 20.5528L3.72361 18.5528C3.893 18.214 4.23926 18 4.61803 18L19.382 18Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
    </svg>
  )
}